"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("../utils/safeInstanceOf");
function contains(container, contained, treatSameNodeAsContain) {
    if (!container || !contained) {
        return false;
    }
    if (treatSameNodeAsContain && container == contained) {
        return true;
    }
    if (safeInstanceOf_1.default(contained, 'Range')) {
        contained = contained && contained.commonAncestorContainer;
        treatSameNodeAsContain = true;
    }
    if (contained && contained.nodeType == 3 /* Text */) {
        contained = contained.parentNode;
        treatSameNodeAsContain = true;
    }
    if (container.nodeType != 1 /* Element */ && container.nodeType != 11 /* DocumentFragment */) {
        return !!treatSameNodeAsContain && container == contained;
    }
    return (!!(treatSameNodeAsContain || container != contained) &&
        internalContains(container, contained));
}
exports.default = contains;
function internalContains(container, contained) {
    if (container.contains) {
        return container.contains(contained);
    }
    else {
        while (contained) {
            if (contained == container) {
                return true;
            }
            contained = contained.parentNode;
        }
        return false;
    }
}
//# sourceMappingURL=contains.js.map